import { ConfirmationDialog } from "core/components/global/confirmationDialogBox/confirmationDialog";
import { styled } from "styled-components";

export const CustomConfirmationDialog = styled(ConfirmationDialog)`
    .MuiPaper-root {
        display: flex;
        align-items: center;
    }
    
    .MuiDialogContent-root {
        width: 75%;
        text-align: center;
    }
`